export var RuleOperator;
(function (RuleOperator) {
    RuleOperator[RuleOperator["CONTAINS"] = 1] = "CONTAINS";
    RuleOperator[RuleOperator["CONTAINS_ALL"] = 2] = "CONTAINS_ALL";
    RuleOperator[RuleOperator["NOT_CONTAINS"] = 3] = "NOT_CONTAINS";
    RuleOperator[RuleOperator["IS"] = 4] = "IS";
    RuleOperator[RuleOperator["NOT"] = 5] = "NOT";
    RuleOperator[RuleOperator["IS_SET"] = 6] = "IS_SET";
    RuleOperator[RuleOperator["NOT_SET"] = 7] = "NOT_SET";
})(RuleOperator || (RuleOperator = {}));
//# sourceMappingURL=rule-operators-type.enum.js.map